"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  author: "Robert Chen",
  quote: "Beacon Finance Group made our refinancing process seamless. Their expertise in the mortgage market is truly unparalleled.",
  position: "Homeowner",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686387/img/client_robert_chen.png"
}, {
  author: "Sarah Miller",
  quote: "The team provided guided clarity throughout our first home purchase. I couldn't have asked for a more professional partner.",
  position: "First-Time Buyer",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686387/img/client_sarah_miller.png"
}];
export default function ClientSuccessStories() {
  return <section data-section-id="235172" id="client-success-stories" className="py-24 md:py-32 bg-background text-foreground overflow-hidden relative">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-primary/5 blur-[120px]" />
        <div className="absolute top-[60%] -right-[10%] w-[40%] h-[40%] rounded-lg bg-secondary/10 blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-6xl relative z-10">
        <div className="mb-16 md:mb-24 text-center md:text-left">
          <h2 className="text-4xl md:text-5xl font-default font-bold text-primary mb-6 tracking-tight uppercase">
            Client Success Stories
          </h2>
          <div className="h-1 w-24 bg-secondary mx-auto md:mx-0" />
        </div>

        <Carousel opts={{
        loop: true,
        align: "start",
        duration: 40
      }} className="w-full">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col justify-between h-full p-8 md:p-16 bg-card border border-primary/5 shadow-xl rounded-md relative overflow-hidden group">
                  {}
                  <Quote className="absolute top-8 left-8 w-32 h-32 text-primary/10 -z-10 rotate-180 transition-transform duration-700 group-hover:scale-110" />

                  <div className="relative z-10">
                    <div className="flex gap-1.5 mb-10">
                      {[...Array(5)].map((_, starIdx) => <Star key={starIdx} data-index={starIdx} className="w-6 h-6 fill-secondary/40 text-secondary/40" />)}
                    </div>
                    <blockquote className="text-3xl md:text-5xl font-default font-medium text-foreground leading-tight md:leading-snug mb-16 max-w-4xl">
                      "{testimonial.quote}"
                    </blockquote>
                  </div>

                  <div className="flex items-center gap-5 relative z-10">
                    <SafeHydrate><Avatar className="w-16 h-16 border-2 border-muted shadow-sm rounded-md">
                      <AvatarImage src={testimonial.avatar} alt={testimonial.author} className="object-cover" />
                      <AvatarFallback className="font-default text-lg bg-primary text-primary-foreground">
                        {testimonial.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div>
                      <div className="font-default font-bold text-lg text-primary">
                        {testimonial.author}
                      </div>
                      <div className="text-base font-mono text-muted-foreground uppercase tracking-wider">
                        {testimonial.position}
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex justify-end gap-4 mt-10 md:mt-12 pr-4 md:pr-8">
            <CarouselPrevious className="static translate-y-0 translate-x-0 size-14 rounded-md border-2 border-primary bg-transparent text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 shadow-md" />
            <CarouselNext className="static translate-y-0 translate-x-0 size-14 rounded-md border-2 border-primary bg-transparent text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 shadow-md" />
          </div>
        </Carousel>
      </div>
    </section>;
}